import { render, staticRenderFns } from "./UserMiniAvatar.vue?vue&type=template&id=0342c157&"
import script from "./UserMiniAvatar.vue?vue&type=script&lang=js&"
export * from "./UserMiniAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserMiniAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports